import React, { useState, useEffect, Fragment, useRef, useMemo, useCallback } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import { utils, ResponseCode, LoginUserType, MobileCallbackTypes, AddLogInAmplitude } from "../../utils/Utils";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import { AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxDelete, AsyncAjaxPut, AjaxGenerateToken } from "../Common/AsyncAjaxService";
import "./Style.scss";
import $ from "jquery";
import StyleContent from "./StyleContent";
import VGPopUp from "../Controls/VGPopUp";
import Alert from "react-bootstrap/Alert";
import AddEditStylePopup from "./AddEditStylePopup";
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from "react-router-dom";
import {
     GetBusinessDetails, Logout
} from '../Slice/Business'
import {
     TokenGenerate
} from '../Slice/Token'
import LayoutContent from "components/LayoutList/LayoutContent";
import useGenerateToken from "components/Hook/useGenerateToken";
import store from '../../app/store'
import Mysitepopup from "./Mysitepopup";
import useSession from "components/Hook/useSession";


//circumvent typescript compile errors by declating in JS 
export async function DispathGetBusienssDetails(dispatch,EncryptCode,access_token){
     const Requestdata = {};
   
     
     Requestdata.EncryptCode = EncryptCode;
     Requestdata.access_token = access_token;
     await dispatch(GetBusinessDetails(Requestdata));
}

const StylesList = (props) => {
     const { IsComplete, BusinessID, ReactBusinessId, ReactUserID, UserID, UserType, CDNURL, WebsiteBuilderParentWebsite, IsViewAllowed, IsModifyAllowed, IsShowDomainPurchased, MerchantStyleId, CountryID, BuildInDomain, VagaroURL, AmplitudeBusinessID, IsNewCustomWebSite } = useSelector((state) => state.Business);
     const stat = useSelector((state) => state.Business);
     const { access_token, generate_time } = useSelector((state) => state.Token);

     const isLargeDesktop = useRef(false);
     const isDesktop = useRef(false);
     const isTabletLandscape = useRef(false);
     const isTabletPotrait = useRef(false);
     const filterPopupRef = useRef(null);
     const isProApp = utils.IsFromProApp();

     let currentPageSize = 30;

     const isLargeDesktopWatcher = window.matchMedia("screen and (min-width: 1600px)");
     const isDesktopWatcher = window.matchMedia("screen and (min-width: 1440px)");
     const isTabletLandscapeWatcher = window.matchMedia("screen and (min-width: 1280px)");
     const isTabletPotraitWatcher = window.matchMedia("screen and (min-width: 991px)");

     isLargeDesktop.current = isLargeDesktopWatcher.matches;
     isDesktop.current = isDesktopWatcher.matches;
     isTabletLandscape.current = isTabletLandscapeWatcher.matches;
     isTabletPotrait.current = isTabletPotraitWatcher.matches;

     function updateisLargeDesktop(e) {
          isLargeDesktop.current = e.matches;
     }
     function updateisDesktop(e) {
          isDesktop.current = e.matches;
     }
     function updateisTabletLandscape(e) {
          isTabletLandscape.current = e.matches;
     }
     function updateisTabletPotrait(e) {
          isTabletPotrait.current = e.matches;
     }

     if (isLargeDesktopWatcher.addEventListener || isDesktopWatcher.addEventListener) {
          isLargeDesktopWatcher.addEventListener('change', updateisLargeDesktop);
          isDesktopWatcher.addEventListener('change', updateisDesktop);
          isTabletLandscapeWatcher.addEventListener('change', updateisTabletLandscape);
          isTabletPotraitWatcher.addEventListener('change', updateisTabletPotrait);
          /*  return function cleanup() {
                isLargeDesktopWatcher.removeEventListener('change', updateisLargeDesktop);
                isDesktopWatcher.removeEventListener('change', updateisDesktop)
           } */
     } else {
          isLargeDesktopWatcher.addListener(updateisLargeDesktop);
          isDesktopWatcher.addListener(updateisDesktop);
          isTabletLandscapeWatcher.addListener(updateisTabletLandscape);
          isTabletPotraitWatcher.addListener(updateisTabletPotrait);
          /* return function cleanup() {
               isLargeDesktopWatcher.removeListener(updateisLargeDesktop);
               isDesktopWatcher.removeListener(updateisDesktop);
          } */
     }

     const pageSize = useRef(30);
     if (isLargeDesktop.current) {
          //show 5 per row
          pageSize.current = 30;
          currentPageSize = 30;

     } else if (isDesktop.current) {
          //show 4 per row
          pageSize.current = 32;
          currentPageSize = 32;
     } else if (isTabletLandscape.current) {
          //show 3 per row
          pageSize.current = 30;
          currentPageSize = 30;
     } else if (isTabletPotrait.current) {
          //show 2 per row
          pageSize.current = 30;
          currentPageSize = 30;
     } else {

          pageSize.current = 30;
          currentPageSize = 30;
     }


     const { EncryptCode } = useParams();
     const currentPage = useRef(1);
     const Loading = useRef(false);
     const pagetotalitems = useRef(0);


     const [category, setCategory] = useState([]);
     const [allcategory, setAllcategory] = useState([]);
     const [tempCategory, setTempCategory] = useState("");
     const [subCategory, setSubCategory] = useState([]);
     const [filterSubCategory, setFilterSubCategory] = useState([]);
     const [styleList, setStyleList] = useState([]);
     const [isExistStyle, setisExistStyle] = useState(false);
     const [totalCount, setTotalCount] = useState(0);

     const categoryId = useRef("");
     const SelectedcategoryId = useRef("");
     const [selectCategoryId, setSelectCategoryId] = useState(categoryId.current);
     const subCategoryId = useRef("");
     const [selectSubCategoryId, setSelectSubCategoryId] = useState(subCategoryId.current);
     const activeStyle = useRef(false);
     const [isActiveStyle, setIsActiveStyle] = useState(false);
     const inActiveStyle = useRef(false);
     const [isInActiveStyle, setIsInActiveStyle] = useState(false);
     const isPopularStyle = useRef(false);
     const [isPopuplar, setIsPopuplar] = useState(false);
     const isNewestStyle = useRef(false);
     const [isNewest, setIsNewest] = useState(false);

     const [isLoading, setLoading] = useState(false);
     const [isStencilsLoader, setIsStencilsLoader] = useState(false);
     const [firstTimeBinding, setFirstTimeBinding] = useState(false);
     const [IsMessageOpen, setIsMessageOpen] = useState(false);
     const [IsMessageOpenNew, setIsMessageOpenNew] = useState(false);
     const [Message, setMessage] = useState("");
     const [allStyleName, setAllStyleName] = useState([]);
     const [allLayoutName, setAllLayoutName] = useState([]);
     const [getstartshow, setGetstartshow] = useState(true);


     // added new for layout panel
     const [showlayoutPanel, setShowLayoutPanel] = useState(false);
     // end layout panel 

     const layoutlist = useRef([]);

     const VagaroAPIEnum = {
          StyleCategorySubCategory: "style/stylecategorysubcategory",
          GetStyleList: "style/stylelist",
          ActivateStyle: "style/publish",
          DeactivateStyle: "style/deactivate",
          DeleteStyle: "style/delete",
          GetStyleDetails: "style/getstyledetails",
          StartOverNewStyle: BusinessID + "/websitebuilders/startovernewlayout",
          ChangeStyle: BusinessID + "/websitebuilders/changesstyle",
          ChangeSquance: "style/changesquance",
          Getlayoutlist: "layout/layoutlist",
          StartFromStratchLayout: "layout/startfromstratchlayout",
          StartFromStratch: "style/startfromstratch",
          MerchantStartfromStratch: BusinessID + "/websitebuilders/startfromstratch",
          GetAllStyleName: "style/getallstylename",
          GetAllLayoutName: "layout/getalllayoutname",
          UpdateToken: "Token/generatetoken",
          AddLogInAmplitude: "amplitude/addloginamplitude"
     };

     const [isSessionCheck, setIsSessionChecked] = useState(false);

     const CheckSession = async () => {
          setLoading(true);
          setIsSessionChecked(false);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setIsSessionChecked(true);
               setLoading(false);
               if (data == true) {
                    currentPage.current = 1;
                    if (isLargeDesktop.current) {
                         currentPageSize = 30;
                    } else if (isDesktop.current) {
                         currentPageSize = 32;
                    } else {
                         currentPageSize = 30;
                    }
                    pageSize.current = currentPageSize;
                    PageLoadEvent();
                    getLayoutList("", false, true, 1, pageSize.current);
                    setShowLayoutPanel(false);
               }
          })
     }

     useEffect(() => {
          GetBusinessDataCollection();
     }, [ReactBusinessId]);

     const MobileCallBack = () => {
          window.setMobileData = (res) => {
               let Response = JSON.parse(res);
               if (Response.callbackIndex) {
                    if (Response.callbackIndex == 60) {
                         if (Response.actionResponse && Response.actionResponse.openWebControls == 2) {
                              if (filterPopupRef.current) {
                                   filterPopupRef.current.click()
                              }
                         }
                    }
                    if (Response.callbackIndex == 69) {
                         if (Response.ReactReportIndex == 61) {
                              utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "VAGARO Change Style", 1, 60);
                              unmountComponentAtNode(document.getElementById("OpenDialog"));
                         }
                         if (Response.ReactReportIndex == 62) {
                              utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "VAGARO Change Style", 1, 60);
                              setShowLayoutPanel(false);
                              unmountComponentAtNode(document.getElementById("lypnl"));
                         }
                    }
               }

          }
     }

     const { StyleId } = useParams();

     useEffect(() => {
          if (props.updatelayout) {
               if (!utils.isNullEmptyOrWhiteSpace(StyleId)) {
                    Showlayout(StyleId);
               }
          }
     }, [styleList]);

     const dispatch = useDispatch();
     useEffect(() => {
          GetToken();
          if (isProApp) {
               utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "VAGARO Change Style", 1, 60);
               MobileCallBack()
          }
     }, []);

     const GetToken = async () => {
          if (typeof generate_time == "undefined" ||
               generate_time == null ||
               generate_time == "" || Date.parse(new Date()) > generate_time) {
               await dispatch(TokenGenerate());
          }
     }


     const GetBusinessDataCollection = async () => {
          if (typeof EncryptCode !== "undefined" &&
               EncryptCode !== null &&
               EncryptCode !== "" && utils.Validate(access_token)) {
               const Requestdata = {};
               Requestdata.EncryptCode = EncryptCode;
               Requestdata.access_token = access_token;
               setLoading(true);
               await dispatch(GetBusinessDetails(Requestdata));
               currentPage.current = 1;
               if (isLargeDesktop.current) {
                    currentPageSize = 30;
               } else if (isDesktop.current) {
                    currentPageSize = 32;
               } else {
                    currentPageSize = 30;
               }
               pageSize.current = currentPageSize;
               PageLoadEvent();
               getLayoutList("", false, true, 1, pageSize.current);
               setShowLayoutPanel(false);
               let queryString = window.location.search;
               if (queryString == undefined || queryString == null || queryString == "" || !queryString.includes("IsFromProAppMobile=true")) {
                    RedirectPage();
               }
          }
          else if (ReactBusinessId == -2) {
               window.location.replace(WebsiteBuilderParentWebsite + "login");
          }
          else {
               await CheckSession();
          }
     }
     const navigate = useNavigate();
     const RedirectPage = () => {
          const { MerchantLayoutId, MerchantStyleId } = store.getState().Business;
          let queryString = window.location.search;
          if (queryString == undefined || queryString == null || queryString == "" || !queryString.includes("IsFromProAppMobile=true")) {
               if (typeof MerchantLayoutId != "undefined" &&
                    MerchantLayoutId != null &&
                    MerchantLayoutId != "" &&
                    typeof MerchantStyleId != "undefined" &&
                    MerchantStyleId != null &&
                    MerchantStyleId != "") {
                    let a = document.createElement('a');
                    a.target = '_self';
                    a.href = "/business/" + MerchantStyleId + "/" + MerchantLayoutId + "/designer";
                    a.click();
               }
               else {
                    if (!utils.IsFromProApp()) {
                         navigate('/');
                    }
               }
          }
     }

     const PageLoadEvent = async () => {
          if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 && utils.Validate(access_token)) {
               setFirstTimeBinding(true);
               categorySubCategoryBinding(false, "", "");
               if (ReactBusinessId <= 0) {
                    utils.SetPageTitle("Style List");
               }
               else {
                    utils.SetPageTitle("Change Style");
               }
               StyleBinding(false, false, true);
               GetAllStyleName();
               GetAllLayoutName();
               handleScrollStyles();
               cardWrapperheight();
               window.addEventListener('resize', cardWrapperheight);
          }
     }

     const categorySubCategoryBinding = async (IsCallback, selectionCategoryId, selectionSubCategoryId) => {
          if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 && utils.Validate(access_token)) {
               const Requestdata = {
                    StyleId: "",
                    CatagoryId: "",
                    MerchantId: BusinessID

               };
               await AsyncAjaxPost(
                    VagaroAPIEnum.StyleCategorySubCategory,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null && data.data.data.displayCategory != null) {
                                        setCategory(data.data.data.displayCategory);
                                        if (IsCallback) {
                                             CallbackFilterSubCategory(selectionCategoryId, data.data.data.subCategory);
                                        }
                                   }
                                   else {
                                        setCategory([]);
                                   }
                                   if (data != null && data.data != null && data.data.data != null && data.data.data.category != null) {
                                        var parentCat = data.data.data.category.filter(x => x.parentCategoryId == "");
                                        var GroupProp = []
                                        parentCat.map(cat =>
                                             GroupProp.push({
                                                  "text": cat.name,
                                                  "children": data.data.data.category.filter(val => val.parentCategoryId == cat.id).map((val) => ({ id: val.id, text: val.name }))
                                             })
                                        )
                                        setAllcategory(GroupProp)
                                        if (IsCallback) {
                                             CallbackFilterSubCategory(selectionCategoryId, data.data.data.subCategory);
                                        }
                                   }
                                   else {
                                        setAllcategory([])
                                   }
                                   if (data != null && data.data != null && data.data.data != null && data.data.data.subCategory != null) {
                                        var subCat = (data.data.data.subCategory || []).sort((a, b) => a.name.localeCompare(b.name))
                                        setSubCategory(subCat);
                                        if (IsCallback) {
                                             CallbackSubCategory(selectionSubCategoryId);
                                        }
                                        else {
                                             setSelectCategoryId("");
                                             setFilterSubCategory(data.data.data.subCategory);


                                        }

                                   }
                                   else {
                                        setSubCategory([]);
                                        setFilterSubCategory([]);
                                   }
                              }
                         }
                         catch (error) {
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Category SubCategory",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Category SubCategory",
                              null,
                              ""
                         );
                    }
               );
          }
     };

     const firstUpdateCategory = useRef(true);
     useEffect(() => {
          if (firstUpdateCategory.current) {
               firstUpdateCategory.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    categoryId.current = selectCategoryId;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [selectCategoryId, SelectedcategoryId.current]);

     const firstUpdateSubCategoryID = useRef(true);
     useEffect(() => {
          if (firstUpdateSubCategoryID.current) {
               firstUpdateSubCategoryID.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    subCategoryId.current = selectSubCategoryId;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [selectSubCategoryId]);


     const firstUpdateIsActiveStyle = useRef(true);
     useEffect(() => {
          if (firstUpdateIsActiveStyle.current) {
               firstUpdateIsActiveStyle.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    activeStyle.current = isActiveStyle;
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [isActiveStyle]);

     const firstUpdateIsInActiveStyle = useRef(true);
     useEffect(() => {
          if (firstUpdateIsInActiveStyle.current) {
               firstUpdateIsInActiveStyle.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    inActiveStyle.current = isInActiveStyle;
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [isInActiveStyle]);

     const firstUpdateIsPopuplar = useRef(true);
     useEffect(() => {
          if (firstUpdateIsPopuplar.current) {
               firstUpdateIsPopuplar.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    isPopularStyle.current = isPopuplar;
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [isPopuplar]);

     const firstUpdateIsNewest = useRef(true);
     useEffect(() => {
          if (firstUpdateIsNewest.current) {
               firstUpdateIsNewest.current = false;
          } else {
               if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
                    isNewestStyle.current = isNewest;
                    currentPage.current = 1;
                    pageSize.current = currentPageSize;
                    StyleBinding(false, false, false);
                    document.querySelector("#stylesWrapper").scrollTop = 0;
               }
          }
     }, [isNewest]);

     const cardWrapperheight = (e) => {
          var wHeight = $(window).height();
          var titleHeight
          if ($(".titleWrapper").length) {
               titleHeight = $(".titleWrapper").outerHeight(true) + 20;
          } else {
               titleHeight = 0;
          }

          var tabHeight
          if ($(".styles-tabs-wrapper .vg-tabs").length) {
               tabHeight = $(".styles-tabs-wrapper .vg-tabs").outerHeight(true) + 24;
          } else {
               tabHeight = 0;
          }
          var tagsheight
          if ($(".styles-tags-wrapper").length) {
               tagsheight = $(".styles-tags-wrapper").outerHeight(true);
          } else {
               tagsheight = 0;
          }

          var calCardWrapperHeight = wHeight - titleHeight - tabHeight - tagsheight - 55;
          $("#stylesWrapper").addClass('js-hasScroll').css("max-height", calCardWrapperHeight);
          handleScrollStyles();
     }

     const handleScrollStyles = (e) => {
          if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
               $('#stylesWrapper').on('scroll', function () {
                    const bottom = parseInt($(this).scrollTop() + $(this).innerHeight()) >= parseInt($(this)[0].scrollHeight);
                    if (bottom && Loading.current == false) {
                         Loading.current = true;
                         if ((currentPage.current * pageSize.current) < pagetotalitems.current) {
                              currentPage.current = currentPage.current + 1;
                              StyleBinding(true, false, false);
                         }
                    }
               });
          }
     }
     const GetAllStyleName = async () => {
          if (utils.Validate(access_token)) {
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetAllStyleName,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.data != null
                                   ) {
                                        setAllStyleName(data.data.data);
                                   } else {
                                        setAllStyleName([]);
                                   }
                              }
                         } catch (error) { }
                    },
                    function OnError() { }
               );
          }
     };

     const GetAllLayoutName = async () => {
          if (utils.Validate(access_token)) {
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetAllLayoutName,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.data != null
                                   ) {
                                        setAllLayoutName(data.data.data);
                                   } else {
                                        setAllLayoutName([]);
                                   }
                              }
                         } catch (error) { }
                    },
                    function OnError() { }
               );
          }
     };
     const AllStyleNameOperation = async (Operation, Id, Title) => {
          if (Operation == "Delete") {
               let newAllStyle = allStyleName.filter(
                    (col) => col.styleId !== Id
               );
               setAllStyleName(newAllStyle);
          }
          else if (Operation == "Edit") {
               setAllStyleName(curr => curr.map(data => {
                    if (data.styleId === Id) {
                         return { ...data, styleName: Title }
                    }
                    return data;
               }),
               );
          }
          else if (Operation == "Add") {
               let newAllStyle = allStyleName;
               newAllStyle.push({ styleId: Id, styleName: Title });
               setAllStyleName(newAllStyle);
          }
     }
     const AllLayoutNameOperation = async (Operation, Id, Title) => {
          if (Operation == "Delete") {
               var newAllLayout = allLayoutName.filter(
                    (col) => col.layoutId !== Id
               );
               setAllLayoutName(newAllLayout);
          }
          else if (Operation == "Edit") {
               setAllLayoutName(curr => curr.map(data => {
                    if (data.layoutId === Id) {
                         return { ...data, layoutName: Title }
                    }
                    return data;
               }),
               );
          }
          else if (Operation == "Add") {
               let newAllLayout = allLayoutName;
               newAllLayout.push({ layoutId: Id, layoutName: Title });
               setAllLayoutName(newAllLayout);
          }
     }

     const UdateStyleState = (type, data) => {
          const Styles = styleList;
          if (type == "Edit") {
               const Style = Styles.map(curr => {
                    if (curr.id == data.ID) {
                         return {
                              ...curr,
                              categoryid: data.CategoryId,
                              styleImage: data.StyleImage,
                              styleTitle: data.StyleTitle,
                              subCategoryId: data.SubCategoryId,
                              isNewest: data.IsNewest

                         }
                    }
                    return { ...curr };
               })
               setStyleList(Style);
          }
          if (type == "Delete") {
               var newStyles = Styles.filter(
                    (col) => col.id !== data
               );
               setStyleList(newStyles);
          }
          handleScrollStyles();
          cardWrapperheight();
     };
     const StyleBinding = async (IsStateAppend, IsStartFromOne, IsFirtTimeBinding, callBack) => {
          if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 && utils.Validate(access_token)) {
               setIsStencilsLoader(true);
               const Requestdata = {};
               Requestdata.CategoryID = SelectedcategoryId.current;
               // Requestdata.CategoryID = categoryId.current;
               Requestdata.SubCategoryID = subCategoryId.current;
               const arrFilter = [];
               if (activeStyle.current) {
                    arrFilter.push(1);
               }
               if (inActiveStyle.current) {
                    arrFilter.push(2);
               }
               Requestdata.Filter = arrFilter;
               const arraySorting = [];
               if (isNewestStyle.current) {
                    arraySorting.push(1);
               }
               if (isPopularStyle.current) {
                    arraySorting.push(2);
               }
               Requestdata.Sortedby = arraySorting;
               Requestdata.PageIndex = IsStartFromOne ? 1 : currentPage.current;
               Requestdata.PageSize = pageSize.current;
               Requestdata.MerchantId = ReactBusinessId;
               Requestdata.LoginUserId = ReactUserID;
               await AsyncAjaxPost(
                    VagaroAPIEnum.GetStyleList,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null && data.data.data.styleList != null) {
                                        if (IsStateAppend) {
                                             let objdata = data.data.data.styleList;
                                             setStyleList(prevstyleList => ([...prevstyleList, ...objdata]));

                                        }
                                        else {
                                             if (data.data.data.styleList.length == 0) {

                                                  setStyleList([]);
                                                  pagetotalitems.current = 0;

                                             }
                                             else {
                                                  const sortedData = data.data.data.styleList.sort((a, b) => {

                                                       const A = a.businessTemplateIdentity !== '';
                                                       const B = b.businessTemplateIdentity !== '';

                                                       if (A && !B) {
                                                            return -1;
                                                       } else if (!A && B) {
                                                            return 1;
                                                       } else {
                                                            return 0;
                                                       }
                                                  });
                                                  setIsStencilsLoader(true)
                                                  setStyleList(sortedData);
                                                  pagetotalitems.current = data.data.data.styleList[0].overallCount;
                                             }
                                        }
                                   }
                                   else {
                                        setStyleList([]);
                                   }

                                   if (data != null && data.data != null && data.data.data != null && data.data.data.isExistStyle != null) {
                                        setisExistStyle(data.data.data.isExistStyle);
                                   }
                                   if (data != null && data.data != null && data.data.data != null && data.data.data.totalCount != null) {

                                        setTotalCount(data.data.data.totalCount);
                                   }
                              }
                              if (IsFirtTimeBinding) {
                                   setFirstTimeBinding(false);
                              }
                              Loading.current = false;
                              setTimeout(() => {
                                   setIsStencilsLoader(false);
                              }, 500);
                              cardWrapperheight();
                         }
                         catch (error) {
                              Loading.current = false;
                              setIsStencilsLoader(false);

                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Admin Style List",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         Loading.current = false;
                         setIsStencilsLoader(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Admin Style List",
                              null,
                              ""
                         );
                    }
               );

               if (callBack) { callBack() };
          }
     };

     const CallbackFilterSubCategory = (categoryId, paramsubcategory) => {
          if (categoryId != "") {
               var FilterSubCategory = paramsubcategory.filter(
                    (col) => col.parentCategoryId === categoryId
               );
               $(".category").each(function () {
                    $(this).removeClass("active");
               });
               $("#" + categoryId).addClass("active");
               setFilterSubCategory(FilterSubCategory);
          }
          else {
               $(".category").each(function () {
                    $(this).removeClass("active");
               });
               $("#categoryall").addClass("active");
               setFilterSubCategory(paramsubcategory);
          }
     }

     const getSubCategory = (categoryId) => {
          $(".category").each(function () {
               $(this).removeClass("active");
          });
          if (categoryId != "") {
               var Catagorys = SelectedcategoryId.current !== "" ? SelectedcategoryId.current.split(",") : [];
               var DisplauCatagorys = category.map(cat => cat.id).join(",");
               var moreCat = false
               if (SelectedcategoryId.current.includes(categoryId)) {
                    Catagorys = Catagorys.filter((val) => val != categoryId);
               } else {
                    Catagorys.push(categoryId)
               }
               var FilterSubCategory = subCategory.filter(
                    (col) => Catagorys.includes(col.parentCategoryId)
               );

               for (let index = 0; index < Catagorys.length; index++) {
                    const element = Catagorys[index];
                    $("#" + element).addClass("active");
                    if (!DisplauCatagorys.includes(element)) {
                         moreCat = true;
                    }
               }

               if (Catagorys.length === 0) {
                    $("#categoryall").addClass("active");
               }
               else if (moreCat) {
                    $("#categorymore").addClass("active");
               }

               SelectedcategoryId.current = Catagorys.join(",").toString();
               setFilterSubCategory(FilterSubCategory);
          }
          else {

               $("#categoryall").addClass("active");
               setFilterSubCategory(subCategory);
               setSelectCategoryId("");
               SelectedcategoryId.current = "";
          }
          subCategorySelection("");
          setSelectCategoryId(categoryId);
     };

     const CallbackSubCategory = (subCategoryId) => {
          $(".subcategory").each(function () {
               $(this).removeClass("add-style");
          });
          if (subCategoryId != "") {
               $("#" + subCategoryId).addClass("add-style");
          }
          else {
               $("#subcategoryall").addClass("add-style");
          }
     };

     const subCategorySelection = (subCategoryId, SelectAll) => {
          $(".subcategory").each(function () {
               $(this).removeClass("add-style");
          });
          if (subCategoryId !== "") {
               var subCatagorys = selectSubCategoryId !== "" ? selectSubCategoryId.split(",") : [];
               if (SelectAll) {
                    subCatagorys = subCategoryId !== "" ? subCategoryId.split(",") : [];
               } else {
                    if (selectSubCategoryId.includes(subCategoryId)) {
                         subCatagorys = subCatagorys.filter((val) => val != subCategoryId);
                    } else {
                         subCatagorys.push(subCategoryId)
                    }
               }
               for (let index = 0; index < subCatagorys.length; index++) {
                    const element = subCatagorys[index];
                    $("#" + element).addClass("add-style")
               }
               if (subCatagorys.length === 0) {
                    $("#subcategoryall").addClass("add-style")
               }
               var str = subCatagorys.join(",").toString()
               setSelectSubCategoryId(str);
          }
          else {
               $("#subcategoryall").addClass("add-style");
               setSelectSubCategoryId("");
          }
     };

     const EditStylePopup = async (StyleID, duplicate) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to edit style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxGet(
                         VagaroAPIEnum.GetStyleDetails + "?StyleID=" + StyleID,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null) {
                                             setLoading(false);
                                             pageSize.current = (currentPage.current * currentPageSize);
                                             return ReactDom.render(
                                                  <AddEditStylePopup
                                                       ReactBusinessId={ReactBusinessId}
                                                       ReactUserID={ReactUserID}
                                                       styleDetails={data.data.data}
                                                       isDuplicate={duplicate}
                                                       StyleID={StyleID}
                                                       StyleBinding={StyleBinding}
                                                       UdateStyleState={UdateStyleState}
                                                       IsMessageOpen={setIsMessageOpen}
                                                       Message={setMessage}
                                                       UserType={UserType}
                                                       categorySubCategoryBinding={(cat, subcat) => { categorySubCategoryBinding(true, cat, subcat) }}
                                                       selectionCategoryId={categoryId}
                                                       selectionSubCategoryId={subCategoryId}
                                                       CDNURL={CDNURL}
                                                       dispatch={dispatch}
                                                       isBuilderPage={false}
                                                       allStyleName={allStyleName}
                                                       allStyleNameOperation={AllStyleNameOperation}
                                                  />,
                                                  document.getElementById("OpenDialog"))
                                        }
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Get Specific Style Details",
                                        StyleID,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Specific Style Details",
                                   StyleID,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const EditStyleSetting = async (StyleID) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to edit Style.", "OpenDialog");
          }
          else {
               await EditStylePopup(StyleID, false);
          }
     }

     const StartFromStratchLayout = async (StyleID) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to edit style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.Created_by = ReactUserID;
                    await AsyncAjaxPost(
                         VagaroAPIEnum.StartFromStratchLayout,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        var layoutid = data.data.data;
                                        if (layoutid != "") {
                                             if (data != null && data.data != null && data.data.data != null) {
                                                  let a = document.createElement('a');
                                                  a.target = '_self';
                                                  a.href = "/admin/" + StyleID + "/" + layoutid + "/designer";
                                                  a.click();
                                             }
                                        }
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Get Specific Style Details",
                                        StyleID,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Specific Style Details",
                                   StyleID,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const DuplicateStyleSetting = async (StyleID) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to duplicate Style.", "OpenDialog");
          }
          else {
               await EditStylePopup(StyleID, true);
          }
     }

     const AddStylePopup = async (styleId) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to add Style.", "OpenDialog");
          }
          else {
               pageSize.current = (currentPage.current * currentPageSize);
               return ReactDom.render(
                    <AddEditStylePopup
                         ReactBusinessId={ReactBusinessId}
                         ReactUserID={ReactUserID}
                         styleDetails={null}
                         isDuplicate={false}
                         StyleID={""}
                         getSubCategory={getSubCategory}
                         StyleBinding={StyleBinding}
                         UdateStyleState={UdateStyleState}
                         IsMessageOpen={setIsMessageOpen}
                         Message={setMessage}
                         UserType={UserType}
                         categorySubCategoryBinding={(cat, subcat) => { categorySubCategoryBinding(true, cat, subcat) }}
                         selectionCategoryId={categoryId}
                         selectionSubCategoryId={subCategoryId}
                         CDNURL={CDNURL}
                         dispatch={dispatch}
                         isBuilderPage={false}
                         allStyleName={allStyleName}
                         allStyleNameOperation={AllStyleNameOperation}
                    />,
                    document.getElementById("OpenDialog"))
          }
     }

     const UseStyle = (styleId, businessTemplatesId, admintemplateid) => {
          let IsFromProapp = utils.IsFromProApp();
          if (typeof businessTemplatesId !== 'undefined' && businessTemplatesId !== null && businessTemplatesId !== "") {
               let a = document.createElement('a');
               a.target = '_self';
               if (IsFromProapp) {
                    a.href = "/business/" + styleId + "/" + businessTemplatesId + "/designer?isProApp=true";
               }
               else {
                    a.href = "/business/" + styleId + "/" + businessTemplatesId + "/designer";
               }
               a.click();
          }
          else {
               let a = document.createElement('a');
               a.target = '_self';
               a.href = "/admin/" + styleId + "/" + admintemplateid + "/designer";
               a.click();
          }
     }

     useEffect(() => {
          if (IsMessageOpen || IsMessageOpenNew) {
               window.setTimeout(() => {
                    if (IsMessageOpen) {
                         setIsMessageOpen(false);
                    }
                    if (IsMessageOpenNew) {
                         setIsMessageOpenNew(false);
                    }
                    handleScrollStyles();
                    cardWrapperheight();
                    window.addEventListener('resize', cardWrapperheight);
               }, 3000)
          }
     }, [IsMessageOpen, IsMessageOpenNew]);


     const BusinessChangeStyle = async (styleId) => {

          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin && UserType !== LoginUserType.BusinessUser) {
               utils.ShowAlert("Message", "Sorry, You do not have access to change style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token) && IsModifyAllowed) {
                    setLoading(true);



                    let styleResult = null;
                    let lastPublish = "";
                    let portImages = [];

                    await AsyncAjaxGet(
                         BusinessID + "/websitebuilders/getbusinesslayoutstyling",
                         access_token,
                         function onSuccess(data) {
                              styleResult = data?.data?.data?.siteStyling;
                         },
                         function OnError(data) {
                              styleResult = data?.data?.data?.siteStyling;
                         }
                    );

                    if (styleResult) {
                         try {
                              let obj = JSON.parse(styleResult);

                              if (obj.lastPublishDate)
                                   lastPublish = obj.lastPublishDate;
                              if (obj.imageUrls && obj.styling?.imageMapping) {
                                   for (let i = 0; i < obj.imageUrls.length; i++) {
                                        if (
                                             !obj.styling.imageMapping.includes(
                                                  obj.imageUrls[i]
                                             )
                                        ) {
                                             portImages.push(obj.imageUrls[i]);
                                        }
                                   }
                              }
                         } catch (e) {
                              console.warn("invalid style object");
                         }
                    }

                    let success = false;

                    console.log(portImages);
                    await AsyncAjaxPut(
                         VagaroAPIEnum.ChangeStyle + "?styleId=" + styleId,
                         access_token,
                         null,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (
                                             data != null &&
                                             data.data != null &&
                                             data.data.data != null &&
                                             data.data.data.status == true
                                        ) {
                                             success = true;
                                        } else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   } else {
                                        PopupClose();
                                        setLoading(false);
                                   }
                              } catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Change Style",
                                        styleId,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Change Style",
                                   styleId,
                                   ""
                              );
                         }
                    );
                    let newResult = null;
                    if (success) {
                         //get the new style
                         await AsyncAjaxGet(
                              "style/getsitestyling?StyleID=" + styleId,
                              access_token,
                              function onSuccess(data) {

                                   newResult = data?.data?.data?.siteStyling;
                              },
                              function OnError(data) {
                                   newResult = data?.data?.data?.siteStyling;
                              }
                         );

                         try {
                              let newStyleObj = JSON.parse(newResult);
                              if (newStyleObj?.imageUrls) {
                                   newStyleObj.imageUrls = [];
                              }
                              for (let i = 0; i < portImages.length; i++) {
                                   if (!newStyleObj.imageUrls.includes(portImages[i])) {
                                        newStyleObj.imageUrls.push(portImages[i]);
                                   }
                              }

                              newStyleObj.lastPublishDate = lastPublish;
                              //save the
                              await AsyncAjaxPut(
                                   BusinessID +
                                   "/websitebuilders/savebusinesslayoutstyling",
                                   access_token,
                                   JSON.stringify({
                                        SiteStyling: JSON.stringify(newStyleObj)
                                   }),
                                   function onSuccess(data) {


                                   },
                                   function OnError(data) {

                                        success = false;


                                   }
                              );
                         } catch (e) {
                              success = false;
                              console.warn("invalid style object");

                         }

                         if (!success) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Change Style",
                                   styleId,
                                   ""
                              );
                         }
                         else {

                              PopupClose();
                              setLoading(false);
                              pageSize.current = currentPage.current * currentPageSize;
                              StyleBinding(false, true, false);
                              setIsMessageOpen(true);
                              setMessage("Website style has been changed.");

                              setTimeout(() => {
                                   const btn = document.getElementById("edit-style-btn");
                                   btn && btn.click();
                              }, 0);
                         }
                    }
                    else {
                         setLoading(false);
                         utils.ShowAlert("Message", "Oops, something went wrong, pleae try again.", "OpenDialog");
                    }


               }
               else {
                    utils.ShowAlert("Alert", "You do not have access to change style.", "OpenDialog");
               }
          }
     }


     const ViewStyle = (styleId, businessTemplatesId, isExistStyle, style_image) => {
          return ReactDom.render(
               <VGPopUp
                    id={"PreviewBusinessStylePopup"}
                    show={true}
                    onHide={PopupClose}
                    title={"Preview"}
                    dialogClassName="webbuilder-preivew-style"
                    body={
                         <div className="style-priview-wrapper">
                              <div className="style-priview-head responsive-devices-icons">
                                   <button
                                        className="w-button w-button-iconbtn desktop selected"
                                   >
                                        <i className="far fa-desktop" aria-hidden="true" />
                                   </button>
                                   <button
                                        className="w-button w-button-iconbtn tablet"
                                   >
                                        <i className="far fa-tablet-android" aria-hidden="true" />
                                   </button>
                                   <button
                                        className="w-button w-button-iconbtn mobile"
                                   >
                                        <i className="far fa-mobile-android" aria-hidden="true" />
                                   </button>
                              </div>
                              <div className="style-priview-parent">
                                   <div className="style-priview">
                                        <img
                                             className="img-fluid"
                                             src={"https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/" + style_image}
                                        />
                                   </div>
                              </div>
                         </div>

                    }
                    footer={
                         <Fragment>
                              {isExistStyle === true && businessTemplatesId !== "" &&
                                   <a href={"business/webviewer/" + businessTemplatesId} target={"_blank"} className="w-button w-button-secondary">View in Browser</a>
                              }
                              {businessTemplatesId === "" &&
                                   <a href={"admin/webviewer/" + styleId} target={"_blank"} className="w-button w-button-secondary">View in Browser</a>
                              }
                              {isExistStyle === true && businessTemplatesId === "" &&
                                   <button className={"w-button w-button-primary style-" + styleId} onClick={(e) => { BusinessChangeStyle(styleId) }}>Change Style</button>
                              }
                              {isExistStyle === false && businessTemplatesId === "" &&
                                   <button className={"w-button w-button-primary style-" + styleId} onClick={(e) => { UseStyle(styleId) }}>Use Style</button>
                              }
                         </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
               />,
               document.getElementById("OpenDialog"))
     }

     const industoriesPopup = () => {
          var catagory = SelectedcategoryId.current;
          const CheckCheked = (CatagoryId) => {
               if (catagory.includes(CatagoryId)) {
                    return true;
               } else {
                    return false;
               }
          }

          const ApplyChanges = () => {
               $(".category").each(function () {
                    $(this).removeClass("active");
               });
               if (catagory != "") {
                    var cat = catagory !== "" ? catagory.split(",") : [];
                    var DisplauCatagorys = category.map(cat => cat.id).join(",");
                    var moreCat = false
                    for (let index = 0; index < cat.length; index++) {
                         const element = cat[index];
                         $("#" + element).addClass("active");
                         if (!DisplauCatagorys.includes(element)) {
                              moreCat = true;
                         }
                    }
                    if (cat.length === 0) {
                         $("#categoryall").addClass("active");

                    } else if (moreCat) {
                         $("#categorymore").addClass("active");

                    }
                    setSelectCategoryId(catagory)
                    SelectedcategoryId.current = catagory;
               }
               else {
                    $("#categoryall").addClass("active");
                    setSelectCategoryId("");
                    SelectedcategoryId.current = "";
               }
               Close();
          }
          const Close = () => {
               if (isProApp) { utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "VAGARO Change Style", 1, 60) }
               unmountComponentAtNode(document.getElementById("OpenDialog"));
          };

          const ChangeCheked = (event) => {
               var cat = catagory !== "" ? catagory.split(",") : [];
               var value = event.target.id.replace("check_", "");
               if (event.target.checked) {
                    cat.push(value);
               } else {
                    cat = cat.filter(val => val !== value);
               }
               var catagorys = cat.join(",").toString();
               catagory = catagorys;
          }
          if (isProApp) { utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, "Select Style By Industry", 1, 61) }
          return ReactDom.render(
               <VGPopUp
                    id={"PreviewBusinessStylePopup"}
                    show={true}
                    onHide={Close}
                    dialogClassName="filter-industry-popup"
                    title={"Filter By Industry"}
                    body={
                         <div className="category-wrapper">
                              {allcategory.length > 0 && allcategory.map((val) => <>
                                   <div className="category-border-box">
                                        <div className="category-heading-name">{val.text}</div>
                                        <div className="filter-category-inputbox">
                                             {val.children.map((chiled) =>
                                                  <div className="cat-sub-item">
                                                       <Form.Check className="checkbox-custom-inline"
                                                            inline
                                                            label={chiled.text}
                                                            name={chiled.text}
                                                            type={'checkbox'}
                                                            id={`check_${chiled.id}`}
                                                            defaultChecked={CheckCheked(chiled.id)}
                                                            onChange={ChangeCheked}
                                                       />
                                                  </div>
                                             )}
                                        </div>
                                   </div>
                              </>)}
                         </div>
                    }
                    footer={<>
                         <button className="w-button w-button-secondary" onClick={() => Close()} >Cancel</button>
                         <button className="w-button w-button-primary" onClick={() => ApplyChanges()}>Apply</button></>}
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
               />,
               document.getElementById("OpenDialog"))
     }
     const FilterPopup = () => {
          var IsNewest = isNewest
          var IsPopuplar = isPopuplar
          var subCatagorys = selectSubCategoryId;
          const ApplyChanges = () => {
               setIsNewest(IsNewest)
               setIsPopuplar(IsPopuplar)

               if (subCatagorys !== "") {

                    setSelectSubCategoryId(subCatagorys);
               }
               else {

                    setSelectSubCategoryId("");
               }
               Close();
          }
          const Close = () => {
               if (isProApp) { utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "VAGARO Change Style", 1, 60) }
               unmountComponentAtNode(document.getElementById("OpenDialog"));
          };
          const ChangeCheked = (event) => {
               var cat = subCatagorys !== "" ? subCatagorys.split(",") : [];
               var value = event.target.id;
               if (event.target.checked) {
                    cat.push(value);
               } else {
                    cat = cat.filter(val => val !== value);
               }
               var catagorys = cat.join(",").toString();
               subCatagorys = catagorys;
          }
          if (isProApp) { utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, "Filter", 1, 61) }
          return ReactDom.render(
               <VGPopUp
                    id={"PreviewBusinessStylePopup"}
                    show={true}
                    onHide={Close}
                    dialogClassName="filter-industry-popup"
                    title={"Filter By Industry"}
                    body={<>
                         <div className="category-wrapper">
                              <div className="category-border-box">
                                   <div className="category-heading-name">SORT</div>
                                   <div className="filter-category-inputbox">
                                        <div className="cat-sub-item">
                                             <Form.Check
                                                  className="checkbox-custom-inline"
                                                  inline
                                                  type="checkbox"
                                                  id={"chkIsNewest"}
                                                  key={"chkIsNewest"}
                                                  label="Newest"
                                                  defaultChecked={isNewest}
                                                  onChange={(e) => { IsNewest = e.target.checked }}
                                             />
                                        </div>
                                        <div className="cat-sub-item">
                                             <Form.Check
                                                  className="checkbox-custom-inline"
                                                  inline
                                                  type="checkbox"
                                                  id={"chkIsPopuplar"}
                                                  key={"chkIsPopuplar"}
                                                  label="Most Popular"
                                                  defaultChecked={isPopuplar}
                                                  onChange={(e) => { IsPopuplar = e.target.checked }}
                                             />
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div className="category-wrapper">
                              <div className="category-border-box">
                                   <div className="category-heading-name">CATEGORIES</div>
                                   <div className="filter-category-inputbox">
                                        {subCategory.map((d) => {
                                             return (
                                                  <>
                                                       <div className="cat-sub-item">
                                                            <Form.Check
                                                                 className="checkbox-custom-inline"
                                                                 inline
                                                                 type="checkbox"
                                                                 id={d.id}
                                                                 key={d.id}
                                                                 label={d.name}
                                                                 onChange={(e) => ChangeCheked(e)}
                                                                 defaultChecked={SubCatCheked(d.id)}
                                                            />
                                                       </div>
                                                  </>
                                             )
                                        })}
                                   </div>
                              </div>
                         </div>
                    </>
                    }
                    footer={<>
                         <button className="w-button w-button-secondary" onClick={() => Close()} >Cancel</button>
                         <button className="w-button w-button-primary" onClick={() => ApplyChanges()}>Apply</button></>}
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
               />,
               document.getElementById("OpenDialog"))
     }


     const DeactivateStylePopup = (styleId) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to deactivate style.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"DeactivateConformationPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Deactivate Style"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>This style will no longer be displayed to businesses once deactivated. Any users currently using this style will not be affected.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                                   <button className="w-button w-button-destructive-outline" onClick={() => DeactivateStyle(styleId)}>Deactivate Style</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }


     const DeleteStylePopup = (styleId) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to delete Style.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"DeleteConformationPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Delete Style"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>This style will be permanently deleted from your website. Any users currently using this style will not be affected.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                                   <button className="w-button w-button-destructive-outline" onClick={() => DeleteStyle(styleId)}>Delete Style</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }

     const ActivateStylePopup = (styleId) => {
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to activate Style.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"ActivateConformationPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Activate Style"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>This style will be displayed to businesses once activated.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                                   <button className={"w-button w-button-primary"} onClick={() => ActivateStyle(styleId)}>Activate Style</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }


     const DeactivateStyle = async (styleId) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to deactivate Style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.DeactivateStyle + "?styleId=" + styleId,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                             PopupClose();
                                             setLoading(false);
                                             var FilterStyleData = styleList.filter(
                                                  (col) => col.id === styleId
                                             );
                                             if (FilterStyleData.length > 0) {
                                                  FilterStyleData[0].isActive = true;
                                                  FilterStyleData[0].isSoftDelete = true;
                                                  styleList.map((d, i) => {
                                                       if (d.id === styleId) {
                                                            styleList[i] = FilterStyleData[0];
                                                       }
                                                  })
                                                  setStyleList(styleList);
                                             }
                                             setIsMessageOpen(true);
                                             setMessage("Style has been deactivated successfully.");
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Delete Style",
                                        styleId,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Delete Style",
                                   styleId,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const DeleteStyle = async (styleId) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to delete Style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.DeleteStyle + "?styleId=" + styleId,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                             PopupClose();
                                             setLoading(false);
                                             pageSize.current = (currentPage.current * currentPageSize);
                                             UdateStyleState("Delete", styleId)
                                             setIsMessageOpen(true);
                                             setMessage("Style has been deleted successfully.");
                                             AllStyleNameOperation("Delete", styleId);
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Delete Style",
                                        styleId,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Delete Style",
                                   styleId,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const ActivateStyle = async (styleId) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Alert", "You do not have permission to activate Style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxPut(
                         VagaroAPIEnum.ActivateStyle + "?styleId=" + styleId,
                         access_token,
                         null,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                             PopupClose();
                                             setLoading(false);
                                             var FilterStyleData = styleList.filter(
                                                  (col) => col.id === styleId
                                             );
                                             if (FilterStyleData.length > 0) {
                                                  FilterStyleData[0].isActive = true;
                                                  FilterStyleData[0].isSoftDelete = false;
                                                  styleList.map((d, i) => {
                                                       if (d.id === styleId) {
                                                            styleList[i] = FilterStyleData[0];
                                                       }
                                                  })
                                                  setStyleList(styleList);
                                             }
                                             setIsMessageOpen(true);
                                             setMessage("Style has been activated successfully.");
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Activate Style",
                                        styleId,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Activate Style",
                                   styleId,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const PopupClose = () => {
          unmountComponentAtNode(document.getElementById("OpenDialog"));
     };

     const GetStarted = async () => {
          var logobject = {};
          logobject.PageURL = window.location.href;
          logobject.Step = 28;
          logobject.UserAgent = (navigator.userAgent).toLowerCase();
          logobject.UserID = ReactUserID;
          logobject.BusinessID = AmplitudeBusinessID;
          logobject.MySiteURL = BuildInDomain + "/" + VagaroURL;
          logobject.CountryID = CountryID;
          await GetAddLogInAmplitude(logobject);
          window.location.href = "/admin/designservicepage";
     };


     const GetAddLogInAmplitude = async (logobject) => {
          setLoading(true);
          const Requestdata = {};
          Requestdata.PageURL = logobject.PageURL;
          Requestdata.Step = logobject.Step;
          Requestdata.UserAgent = logobject.UserAgent;
          Requestdata.UserID = logobject.UserID;
          Requestdata.BusinessID = logobject.BusinessID;
          Requestdata.MySiteURL = logobject.MySiteURL;
          Requestdata.CountryID = logobject.CountryID;
          await AsyncAjaxPost(
               VagaroAPIEnum.AddLogInAmplitude,
               Requestdata,
               access_token,
               function onSuccess(data) {
                    try {
                         if (data != null && data.data != null && data.data.data != null) {
                              setLoading(false);
                              window.location.href = "/admin/designservicepage"
                         }
                         else {
                              setLoading(false);
                              window.location.href = "/admin/designservicepage"
                         }
                    } catch (error) {
                         console.log("error");
                         setLoading(false);
                         window.location.href = "/admin/designservicepage"
                    }
               },
               function OnError() {
                    console.log("error");
               }
          );
     }

     const StartFromScratchPopup = () => {
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "You do not have access to start from scratch.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"StartFromScratchPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Your Website Content will be Deleted"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>Your current website’s content will be deleted and you will be starting over with a new style and layout.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                                   <button className="w-button w-button-primary" onClick={() => StartFromScratch()}>Start Over</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }

     const StartFromScratch = async () => {
          AmplitudeAfterStartFromScratch();
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin && !IsModifyAllowed) {
               utils.ShowAlert("Alert", "Sorry, You do not have access to start from scratch.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token) && IsModifyAllowed) {
                    setLoading(true);
                    await AsyncAjaxPut(
                         VagaroAPIEnum.StartOverNewStyle,
                         access_token,
                         null,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {

                                             //MerchantStartFromScratch();

                                             StyleBinding(false, true, false,
                                                  () => {
                                                       pageSize.current = (currentPage.current * currentPageSize);
                                                       PopupClose();
                                                       setLoading(false);
                                                       setIsMessageOpen(true);
                                                       setMessage("Your Website content has been successfully deleted.");
                                                       if (window.location.href.includes("/business/" || window.location.href.includes("/admin/"))) {
                                                            let a = document.createElement("a");
                                                            a.target = "_self";
                                                            a.href = window.location.protocol + "//" + window.location.host;
                                                            a.click();
                                                       }
                                                  }
                                             );



                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Start From Scratch",
                                        "",
                                        ""
                                   );
                                   utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Start From Scratch",
                                   "",
                                   ""
                              );
                              utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const MerchantStartFromScratch = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               const Requestdata = {};
               Requestdata.Created_by = ReactUserID;
               await AsyncAjaxPost(
                    VagaroAPIEnum.MerchantStartfromStratch,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        let a = document.createElement('a');
                                        a.target = '_self';
                                        a.href = "/business/" + data.data.data.styleId + "/" + data.data.data.layoutId + "/designer";
                                        a.click();
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              else {
                                   setLoading(false);
                              }
                         }
                         catch (error) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Merchant Start from stratch",
                                   "",
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Merchant Start from stratch",
                              "",
                              ""
                         );
                    }
               );
          }
          else {
               utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
     }

     const ReorderList = async (sourceIndex, destinationIndex) => {
          const access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to reorder Style list.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token) && IsModifyAllowed) {
                    if (styleList[sourceIndex].rank != styleList[destinationIndex].rank) {
                         setLoading(true);
                         const Requestdata = {};
                         Requestdata.SourceStyleRank = styleList[sourceIndex].rank;
                         Requestdata.DestinationStyleRank = styleList[destinationIndex].rank;
                         Requestdata.StyleId = styleList[sourceIndex].id;
                         await AsyncAjaxPost(
                              VagaroAPIEnum.ChangeSquance,
                              Requestdata,
                              access_token,
                              function onSuccess(data) {
                                   try {
                                        if (
                                             data != null &&
                                             data.data != null &&
                                             data.data.responseCode == ResponseCode.Success
                                        ) {
                                             setLoading(false);
                                             pageSize.current = (currentPage.current * currentPageSize);
                                             StyleBinding(false, true, false);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   catch (error) {
                                        setLoading(false);
                                        utils.appInsightTrack(
                                             ReactBusinessId,
                                             ReactUserID,
                                             "Change Squance",
                                             null,
                                             ""
                                        );
                                   }
                              },
                              function OnError() {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Change Squance",
                                        null,
                                        ""
                                   );
                              }
                         );
                    };
               }
               else {
                    utils.ShowAlert("Alert", "You do not have access to change style.", "OpenDialog");
               }
          }
     }

     const layouttotalitems = useRef(0);
     const layoutPageIndex = useRef(1);
     const layoutPagePageSize = useRef(currentPageSize);
     const getLayoutList = async (styleId, IsStateAppend, IsStartFromOne, PageIndex, PageSize) => {
          if (utils.Validate(access_token)) {
               layoutPageIndex.current = PageIndex;
               layoutPagePageSize.current = PageSize;
               setLoading(true);
               const Requestdata = {};
               Requestdata.PageIndex = IsStartFromOne ? 1 : PageIndex;
               Requestdata.PageSize = PageSize;
               Requestdata.MerchantId = ReactBusinessId;
               Requestdata.LoginUserId = ReactUserID;
               await AsyncAjaxPost(
                    VagaroAPIEnum.Getlayoutlist,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        setLoading(false);
                                        if (IsStateAppend) {
                                             data.data.data.map((item) => {
                                                  layoutlist.current.push(item);
                                             })
                                        }
                                        else {
                                             if (data.data.data.length == 0) {
                                                  layoutlist.current = [];
                                                  layouttotalitems.current = 0;
                                             }
                                             else {
                                                  layoutlist.current = (data.data.data);
                                                  layouttotalitems.current = data.data.data[0].overallCount;
                                             }
                                        }
                                   }
                                   else {
                                        layoutlist.current = [];
                                        setLoading(false);
                                   }
                              }
                              else {
                                   layoutlist.current = [];
                                   setLoading(false);

                              }
                              if (styleId != "") {
                                   Showlayout(styleId);
                              }
                              Loading.current = false;
                              setLoading(false);
                              if (IsNewCustomWebSite == false && !utils.IsFromProApp() && ReactBusinessId > 0 && !props.updatelayout) {
                                   return ReactDom.render(
                                        <Mysitepopup

                                        />,
                                        document.getElementById("OpenDialog")
                                   )
                              }
                         }
                         catch (error) {
                              Loading.current = false;
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get LayoutList List",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get LayoutList List",
                              null,
                              ""
                         );
                    }
               );
          }
          else {
               utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
     }

     const setLayoutList = (list) => {
          layoutlist.current = list;
     }

     const Layoutalert = () => {
          setIsMessageOpenNew(true)
          setMessage("You Don't have a layout. Please start from scratch.")
     }

     const Showlayout = (styleId) => {
          if (IsModifyAllowed || IsViewAllowed) {
               setShowLayoutPanel(!showlayoutPanel);
               if (utils.IsFromProApp()) {
                    utils.CallBackGivenToMobileApp(MobileCallbackTypes.TitleWithBack, "Select Website Layout", 1, 62);
               }
               return ReactDom.render(
                    <LayoutContent
                         layoutlist={layoutlist.current}
                         isLoading={isLoading}
                         setLoading={setLoading}
                         setLayoutList={setLayoutList}
                         getLayoutList={getLayoutList}
                         styleId={styleId}
                         layouttotalitems={layouttotalitems.current}
                         layoutPageIndex={layoutPageIndex.current}
                         layoutPagePageSize={layoutPagePageSize.current}
                         allLayoutName={allLayoutName}
                         allLayoutNameOperation={AllLayoutNameOperation}
                         dispatch={dispatch}
                         Loading={Loading.current}
                         useupdatelayout={props.updatelayout}
                    />
                    ,
                    props.updatelayout ? document.getElementById("updatestyleforpopup") : document.getElementById("lypnl"));
          }
          else {
               utils.ShowAlert("Message", "Sorry, You don't have permission to Start with this Style.", "OpenDialog");
          }
     }
     const Hidelayout = () => {
          setShowLayoutPanel(!showlayoutPanel);
          setTimeout(() => {
               unmountComponentAtNode(document.getElementById("lypnl"));
          }, 400);

     }
     const AmplitudeAfterStartFromScratch = async () => {
          const access_token = await useGenerateToken(dispatch);
          var logobject = {};
          logobject.PageURL = window.location.href;
          logobject.Step = 28;
          logobject.UserAgent = (navigator.userAgent).toLowerCase();
          logobject.UserID = ReactUserID;
          logobject.BusinessID = AmplitudeBusinessID;
          logobject.MySiteURL = BuildInDomain + "/" + VagaroURL;
          logobject.CountryID = CountryID;
          logobject.accessToken = access_token;

          await AddLogInAmplitude(logobject);
     };

     const StartFromStratchLayoutStyle = async () => {
          AmplitudeAfterStartFromScratch();
          var access_token = await useGenerateToken(dispatch);
          if (UserType !== LoginUserType.VagaroAdmin) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to edit style.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.Created_by = ReactUserID;
                    await AsyncAjaxPost(
                         VagaroAPIEnum.StartFromStratch,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {

                                        if (data != null && data.data != null && data.data.data != null) {
                                             var reposnse = data.data.data;
                                             if (reposnse.styleId != "" && reposnse.layoutId != "") {
                                                  let a = document.createElement('a');
                                                  a.target = '_self';
                                                  a.href = "/admin/" + reposnse.styleId + "/" + reposnse.layoutId + "/designer";
                                                  a.click();
                                             }
                                        }
                                        setLoading(false);
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Start from Stratch",
                                        "",
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Start from Stratch",
                                   "",
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const SubCatCheked = (CatagoryId) => {
          if (subCategoryId.current.includes(CatagoryId)) {
               return true;
          } else {
               return false;
          }
     }


     return (
          <Fragment>
               {IsComplete && typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 &&
                    <div style={props.updatelayout ? { display: "none" } : { display: "block" }} className={`main-container template-content-wraper ${ReactBusinessId > 0 ? "change-theme-wrapper" : ""}`}>
                         <div className="titleWrapper">
                              {IsMessageOpen &&
                                   <Alert isOpen={IsMessageOpen} variant="success" className="vg-alert-strip vg-passive">
                                        <i className="fas fa-check-circle"></i> {Message}
                                   </Alert>
                              }
                              {IsMessageOpenNew &&
                                   <Alert isOpen={IsMessageOpenNew} variant="warning" className="vg-alert-strip vg-passive" style={{ backgroundColor: "#ff9f08", color: "white" }}>
                                        <i class="fa fa-exclamation-triangle"></i> {Message}
                                   </Alert>
                              }
                              {typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 &&
                                   <Fragment>
                                        <div className="title-with-btn py-t24 page-title-wrap">
                                             {isExistStyle &&
                                                  <h2 className="page-title">Change Style</h2>
                                             }
                                             {!isExistStyle &&
                                                  <h2 className="page-title">Select a Style</h2>
                                             }
                                             {typeof ReactBusinessId !== 'undefined' && ReactBusinessId == 0 &&
                                                  <Fragment>
                                                       <div className="title-with-btn start-from-scratchbtn">
                                                            <div className="title-btn">
                                                                 <a
                                                                      onClick={(e) => { StartFromStratchLayoutStyle() }}
                                                                      className="w-button w-button-ghost">
                                                                      <i className="far fa-plus" aria-hidden="true" />{" "}
                                                                      Start from Scratch
                                                                 </a>
                                                            </div>
                                                       </div>
                                                  </Fragment>
                                             }
                                             {typeof ReactBusinessId !== 'undefined' && ReactBusinessId > 0 &&
                                                  <div className="title-btn start-from-scratchbtn">
                                                       <div>Looking to hire a website expert or migrate your current site? <a href={false} className="get-started" onClick={() => GetStarted()}>Get Started</a></div>
                                                  </div>
                                             }
                                        </div>
                                   </Fragment>
                              }
                         </div>
                         {
                              typeof ReactBusinessId !== 'undefined' &&
                              <div className="styles-tabs-wrapper py-t24">
                                   {category.length > 0 &&
                                        <ul className="vg-tabs nav nav-tabs" role={"tablist"}>
                                             <li className="nav-item" role="presentation">
                                                  <button type="button" role="tab" id="categoryall" onClick={() => getSubCategory("")} className="nav-link category active">
                                                       All Industries
                                                  </button>
                                             </li>
                                             {category.map((d) => {
                                                  return (

                                                       <li className="nav-item" key={d.id} role="presentation">
                                                            <button type="button" role="tab" key={d.id} id={d.id} onClick={() => getSubCategory(d.id)} className="nav-link category">
                                                                 {d.name}
                                                            </button>
                                                       </li>
                                                  )
                                             })}
                                             <li className="nav-item" role="presentation">
                                                  <button type="button" role="tab" id="categorymore" onClick={() => industoriesPopup("")} className="nav-link category">
                                                       More
                                                  </button>
                                             </li>
                                        </ul>
                                   }
                          
                                   {filterSubCategory.length >= 0 && 
                                        <div className="tab-content">
                                             <div role={"tabpanel"} className={`tab-pane active show ${isStencilsLoader ? "loadingSkeletons" : ""}`}>

                                                  <div className="styles-tags-wrapper py-t24">
                                                       <div className={`tamplate-sort ${ReactBusinessId > 0 && "noaddstyle"}`}>
                                                            {
                                                                 isProApp ?
                                                                      <div ref={filterPopupRef} style={{ display: "none" }} className="sort-toggle" onClick={() => FilterPopup()}>Sort</div>

                                                                      :
                                                                      <>
                                                                           <Dropdown
                                                                                className="sort-menu"
                                                                                autoClose="outside"
                                                                                role="menu"

                                                                           >
                                                                                <Dropdown.Toggle
                                                                                     className="sort-toggle"
                                                                                     as={"a"}
                                                                                     role="menuitem"
                                                                                >
                                                                                     Filter
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu align="end">
                                                                                     <div className="select-option-heading-editor" style={{ display: "flex" }}>

                                                                                          <Dropdown.Item className="with-checkbox displa" as={"div"} onClick={() => subCategorySelection(subCategory.map((d) => d.id).join(","), true)}>
                                                                                               <div>Select All</div>
                                                                                          </Dropdown.Item>
                                                                                          <Dropdown.Item className="with-checkbox displa" as={"div"} onClick={() => subCategorySelection("")}>
                                                                                               <div>Select None</div>
                                                                                          </Dropdown.Item>
                                                                                     </div>
                                                                                     {subCategory.map((d, i) => {
                                                                                          return (
                                                                                               <Fragment key={i}>
                                                                                                    <Dropdown.Item
                                                                                                         className="with-checkbox"
                                                                                                         as={"div"}
                                                                                                    >
                                                                                                         <Form.Check
                                                                                                              type="checkbox"
                                                                                                              id={d.id}
                                                                                                              key={d.id}
                                                                                                              label={d.name}
                                                                                                              onChange={() => subCategorySelection(d.id)}
                                                                                                              checked={SubCatCheked(d.id)}
                                                                                                         />
                                                                                                    </Dropdown.Item>
                                                                                               </Fragment>
                                                                                          )
                                                                                     })}

                                                                                </Dropdown.Menu>
                                                                           </Dropdown>
                                                                           <Dropdown
                                                                                className="sort-menu"
                                                                                autoClose="outside"
                                                                                role="menu"
                                                                           >
                                                                                <Dropdown.Toggle
                                                                                     className="sort-toggle"
                                                                                     as={"a"}
                                                                                     role="menuitem"
                                                                                >
                                                                                     Sort
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu align="end">
                                                                                     <Dropdown.Item
                                                                                          className="with-checkbox"
                                                                                          as={"div"}
                                                                                     >
                                                                                          <Form.Check
                                                                                               type="checkbox"
                                                                                               id={"chkIsNewest"}
                                                                                               key={"chkIsNewest"}
                                                                                               label="Newest"
                                                                                               checked={isNewest}
                                                                                               onChange={(e) => { setIsNewest(e.target.checked) }}
                                                                                          />
                                                                                     </Dropdown.Item>
                                                                                     <Dropdown.Item
                                                                                          className="with-checkbox"
                                                                                          as={"div"}
                                                                                     >
                                                                                          <Form.Check
                                                                                               type="checkbox"
                                                                                               id={"chkIsPopuplar"}
                                                                                               key={"chkIsPopuplar"}
                                                                                               label="Most Popular"
                                                                                               checked={isPopuplar}
                                                                                               onChange={(e) => { setIsPopuplar(e.target.checked) }}
                                                                                          />
                                                                                     </Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                           </Dropdown>
                                                                      </>
                                                            }
                                                            {ReactBusinessId === 0 && UserType === LoginUserType.VagaroAdmin &&<a className="w-button w-button-ghost" href="/admin/setlibrary"  style={{marginLeft:"8px"}}>Manage Set Library</a>}
                                                       </div>
                                                  </div>
                                            
                                                  {styleList.length >= 0 &&
                                                       <StyleContent
                                                            isLoading={isLoading}
                                                            isSessionCheck={isSessionCheck}
                                                            isStencilsLoader={isStencilsLoader}
                                                            styleList={styleList}
                                                            EditStyle={ViewStyle}
                                                            DuplicateStyle={DuplicateStyleSetting}
                                                            DeactivateStylePopup={DeactivateStylePopup}
                                                            DeleteStylePopup={DeleteStylePopup}
                                                            ActivateStylePopup={ActivateStylePopup}
                                                            AddStylePopup={AddStylePopup}
                                                            IsFirtTimeBinding={firstTimeBinding}
                                                            ViewStyle={ViewStyle}
                                                            BusinessChangeStyle={BusinessChangeStyle}
                                                            UseStyle={UseStyle}
                                                            EditStyleSetting={EditStyleSetting}
                                                            CreateLayout={StartFromStratchLayout}
                                                            ReorderList={ReorderList}
                                                            isFromParentAll={categoryId.current}
                                                            isFromAll={subCategoryId.current}
                                                            isNewest={isNewest}
                                                            isPopuplar={isPopuplar}
                                                            isActiveStyle={isActiveStyle}
                                                            isInActiveStyle={isInActiveStyle}
                                                            showLayout={Showlayout}
                                                            Layoutalert={Layoutalert}
                                                            layoutlist={layoutlist.current}
                                                            totalCount={totalCount}
                                                            startFromStratchLayoutStyle={StartFromStratchLayoutStyle}
                                                            allLayoutName={allLayoutName}
                                                       ></StyleContent>
                                                  }

                                             </div>
                                        </div>
                                   }
                                   
                              </div>
                         }
                         {/* Layout Panel Start */}
                         <div className={`layout-panel-wrapper ${showlayoutPanel ? "showpanel" : "hidepanel"}`}>
                              <div className="layout-panel-backdrop" onClick={Hidelayout}></div>
                              <div id="lypnl" className="portalLayout"></div>
                         </div>
                         {isProApp && getstartshow &&
                              <>
                                   <div className="get-started-editorsection">
                                        <button className="invisible-button dismiss-getstarted-btn " id="" onClick={() => setGetstartshow(false)} >×</button>
                                        <div className="migrate-get-started" onClick={() => GetStarted()}>
                                             <p className="migrate-get-started-para">Looking to hire a website expert or migrate your current site?</p>
                                             <div className="migrate-get-started-link">Get Started
                                                  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                       <path d="M13.2695 6.54883L8.58203 11.2363C8.40625 11.4121 8.17188 11.5 7.9375 11.5C7.67383 11.5 7.43945 11.4121 7.26367 11.2363C6.88281 10.8848 6.88281 10.2695 7.26367 9.91797L10.3398 6.8125H1.375C0.847656 6.8125 0.4375 6.40234 0.4375 5.875C0.4375 5.37695 0.847656 4.9375 1.375 4.9375H10.3398L7.26367 1.86133C6.88281 1.50977 6.88281 0.894531 7.26367 0.542969C7.61523 0.162109 8.23047 0.162109 8.58203 0.542969L13.2695 5.23047C13.6504 5.58203 13.6504 6.19727 13.2695 6.54883Z" fill="#2A90D6" />
                                                  </svg></div>
                                        </div>
                                   </div>
                              </>
                         }
                         {/* Layout Panel end */}
                    </div>
               }
          </Fragment >
     );
};
export default withAITracking(reactPlugin, StylesList);
